import './public-path';
import './css/site.scss';
// TODO: How to enumerate this?
import './SignIn/css/styles.css';
import 'core-js/es/array';
import 'core-js/es/promise';

import { app } from './app';

app.$mount('#app');

// Being the main entry point for the webpack bundle,
// we can export objects here as properties of the library variable
// and we can also set global variables here.
